import { render, staticRenderFns } from "./settingRedAct.vue?vue&type=template&id=6c5416d2&scoped=true&"
import script from "./settingRedAct.vue?vue&type=script&lang=js&"
export * from "./settingRedAct.vue?vue&type=script&lang=js&"
import style0 from "./settingRedAct.vue?vue&type=style&index=0&id=6c5416d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5416d2",
  null
  
)

component.options.__file = "settingRedAct.vue"
export default component.exports